// extracted by mini-css-extract-plugin
export default {"wrapper":"acl_wrapper__Tpuck","header":"acl_header__rNybB","content":"acl_content__skKok"};